export const WABA_BANNED = "Banned";
export const WABA_RESTORED = "Restored";
export const WABA_WARNED = "Warned";
export const WABA_NORMAL = "Normal";

export const HAPTIK_FB_BUSINESS_MANAGER_ID = "928974617157828";
